var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-steps"},[_c('div',{staticClass:"layout-steps__steps"},[_vm._t("steps")],2),_c('div',{staticClass:"layout-steps__content"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }